require('/opt/odin/app/frontend/pages/landing_xray/index/index.module.scss');module.exports = "../../app/views/tms/landing_xray/index.html.erb";